var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "detailForm",
          attrs: { model: _vm.detailForm, rules: _vm.rules },
        },
        [
          _c("table", { staticClass: "table-d" }, [
            _c("tr", [
              _c("td", [_vm._v("Category2")]),
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { "margin-bottom": "0" },
                      attrs: { prop: "category2Code" },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { clearable: "", placeholder: "请选择" },
                          model: {
                            value: _vm.detailForm.category2Code,
                            callback: function ($$v) {
                              _vm.$set(_vm.detailForm, "category2Code", $$v)
                            },
                            expression: "detailForm.category2Code",
                          },
                        },
                        _vm._l(_vm.categoryList2, function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.name, value: item.code },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("td", [_vm._v("供应商集团名称")]),
              _c("td", [_vm._v(_vm._s(_vm.detailForm.groupName))]),
              _c("td", [_vm._v("Facility编号")]),
              _c("td", [_vm._v(_vm._s(_vm.detailForm.code))]),
            ]),
            _c("tr", [
              _c("td", [_vm._v("Facility名字")]),
              _c("td", [_vm._v(_vm._s(_vm.detailForm.name))]),
              _c("td", [_vm._v("状态")]),
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { "margin-bottom": "0" },
                      attrs: { prop: "status" },
                    },
                    [
                      _c("ic-select", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          clearable: "",
                          table: "TM_QSPI_FACILITY",
                          field: "STATUS",
                        },
                        model: {
                          value: _vm.detailForm.status,
                          callback: function ($$v) {
                            _vm.$set(_vm.detailForm, "status", $$v)
                          },
                          expression: "detailForm.status",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("td"),
              _c("td"),
            ]),
            _c("tr", [
              _c("td", [_vm._v("备注")]),
              _c(
                "td",
                { attrs: { colspan: "6" } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { "margin-bottom": "0" },
                      attrs: { prop: "remark" },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: { type: "textarea", rows: 2, clearable: "" },
                        model: {
                          value: _vm.detailForm.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.detailForm, "remark", $$v)
                          },
                          expression: "detailForm.remark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "el-row",
        { attrs: { type: "flex", justify: "center" } },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.onSave },
            },
            [_vm._v("保存")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }